// store/pieces/usePiecesStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { piecesInitialState, PiecesState } from './piecesInitialState';
import { createPiecesSlice, PiecesActions } from './createPiecesSlice';
/**
 * @french
 * Hook Zustand persistant pour la gestion des pieces comptables.
 */
export const usePiecesStore = create<PiecesState & PiecesActions>()(
  persist(combine(piecesInitialState, createPiecesSlice as any), {
    name: 'pieces-store',
  }),
);
